import React from 'react'

const StatusTimeline = ({ quotation }) => {
  const getTimelineSteps = () => {
    const steps = [
      {
        id: 1,
        label: 'Rascunho',
        icon: '📝',
        completed: quotation?.quotation_status_id >= 1,
        active: quotation?.quotation_status_id === 1,
        date: quotation?.created_at
      },
      {
        id: 2,
        label: 'Ativa',
        icon: '🔵',
        completed: quotation?.quotation_status_id >= 2,
        active: quotation?.quotation_status_id === 2,
        date: quotation?.request_date
      },
      {
        id: 3,
        label: 'Fechada',
        icon: '✅',
        completed: quotation?.quotation_status_id === 3,
        active: quotation?.quotation_status_id === 3,
        date: quotation?.quotation_status_id === 3 ? quotation?.updated_at : null
      }
    ]

    // Add cancelled or expired status if applicable
    if (quotation?.quotation_status_id === 4) {
      steps.push({
        id: 4,
        label: 'Cancelada',
        icon: '❌',
        completed: true,
        active: true,
        date: quotation?.updated_at
      })
    } else if (quotation?.quotation_status_id === 5) {
      steps.push({
        id: 5,
        label: 'Expirada',
        icon: '⏰',
        completed: true,
        active: true,
        date: quotation?.expiration_date
      })
    }

    return steps
  }

  const formatDate = (dateString) => {
    if (!dateString) return ''
    return new Date(dateString).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
  }

  const steps = getTimelineSteps()

  return (
    <div className="bg-white dark:bg-dark-bg-secondary rounded-lg border border-gray-200 dark:border-dark-border-primary p-4 transition-colors">
      <h3 className="text-lg font-semibold text-gray-800 dark:text-dark-text-primary mb-4">Status da Cotação</h3>
      
      <div className="relative">
        {steps.map((step, index) => (
          <div key={step.id} className="flex items-start mb-4 last:mb-0">
            {/* Timeline line */}
            {index < steps.length - 1 && (
              <div className={`absolute left-4 top-8 w-0.5 h-8 ${
                step.completed ? 'bg-green-400 dark:bg-green-500' : 'bg-gray-300 dark:bg-gray-600'
              }`} />
            )}
            
            {/* Step icon */}
            <div className={`relative z-10 flex items-center justify-center w-8 h-8 rounded-full border-2 ${
              step.active 
                ? 'bg-blue-500 dark:bg-dark-accent-green border-blue-500 dark:border-dark-accent-green text-white' 
                : step.completed 
                  ? 'bg-green-500 dark:bg-green-600 border-green-500 dark:border-green-600 text-white'
                  : 'bg-white dark:bg-dark-bg-tertiary border-gray-300 dark:border-gray-600 text-gray-400 dark:text-gray-500'
            }`}>
              <span className="text-xs">{step.icon}</span>
            </div>
            
            {/* Step content */}
            <div className="ml-4 flex-1">
              <div className="flex items-center justify-between">
                <h4 className={`text-sm font-medium ${
                  step.active ? 'text-blue-600 dark:text-dark-accent-green' : step.completed ? 'text-green-600 dark:text-green-400' : 'text-gray-500 dark:text-gray-400'
                }`}>
                  {step.label}
                </h4>
                {step.date && (
                  <span className="text-xs text-gray-500 dark:text-dark-text-muted">
                    {formatDate(step.date)}
                  </span>
                )}
              </div>
              
              {step.active && (
                <p className="text-xs text-gray-600 dark:text-dark-text-secondary mt-1">
                  Status atual da cotação
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default StatusTimeline
